import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import Heading from '../../../generic-components/Heading';
import { STYLES, TEXT } from '../constants';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { FlowContext } from '../index';
import { planReportName } from '../service';
import { useCustomerHelper } from '../../../hooks/utilities/useCustomerHelper';
import {
  LEGAL_DOC_VISA_T_AND_C_SUNRISE,
  LEGAL_DOC_VISA_T_AND_C_CHOICE,
} from '../../../constants/general';
import { LiliCheckbox, LiliCheckboxSize } from '../../../DesignSystem/LiliCheckbox/LiliCheckbox';

interface IProps {
    onTermsConfirmed: () => void
    currentPlan: string
}

export const PlanPickerConfirmation = ({ onTermsConfirmed, currentPlan }: IProps) => {
  const context = useContext(FlowContext);
  const { t } = useTranslation();
  const { t: genT } = useTranslation('generalEn');

  const flowContext = useContext(FlowContext);
  const { mutateReportState, reportsState } = flowContext;
  const { isSunriseCustomer, termsAndConditionsLink, termsAndConditionsLinkTitle } = useCustomerHelper();
  const visaTermsAndConditionsLink = isSunriseCustomer ? LEGAL_DOC_VISA_T_AND_C_SUNRISE : LEGAL_DOC_VISA_T_AND_C_CHOICE;

  const [isTermsConfirmed, setIsTermsConfirmed] = useState<boolean>(false);
  const testIds = [
    {
      selector: '#TERMS_OF_USE_LINK',
      cb: () => trackMixPanel('Act on T&C Dialog', {
        Action: 'Lili Terms of Use',
      }),
    },
    {
      selector: '#TERMS_AND_CONDITIONS_LINK',
      cb: () => trackMixPanel('Act on T&C Dialog', {
        Action: 'Lili T&C',
      }),
    },
    {
      selector: '#VISA_SAVING_LINK',
      cb: () => trackMixPanel('Act on T&C Dialog', {
        Action: 'VSE T&C',
      }),
    },
  ];

  useEffect(() => {
    testIds.forEach(i => {
      const el = document.querySelector(i.selector);
      el?.addEventListener('click', () => i.cb());
    });
    return () => {
      testIds.forEach(i => {
        const el = document.querySelector(i.selector);
        el?.removeEventListener('click', () => {});
      });
    };
  }, []);

  const onTermsConfirmedHandler = () => {
    onTermsConfirmed();
    trackMixPanel('Act on T&C Dialog', {
      Action: 'Continue',
    });
  };
  useEffect(() => {
    if (!reportsState.didReportConfirmationView) {
      trackMixPanel('View T&C Dialog', {
        'Current Plan': planReportName(currentPlan),
      });
      if (mutateReportState) {
        mutateReportState({
          ...reportsState,
          didReportConfirmationView: true,
        });
      }
    }
  }, []);
  const termsHtml = () => `
        <p class="${STYLES.INDEX.PLAN_PICKER.CONFIRMATION.TERMS_OF_USE}">
         I have read the Lili App Inc. 
         <a id='TERMS_OF_USE_LINK' href="https://lili.co/app-terms-of-use" target="_blank" class="${STYLES.INDEX.PLAN_PICKER.CONFIRMATION.TERMS_OF_USE_LINK} ">Terms of Use</a>,
         <a id='TERMS_AND_CONDITIONS_LINK' href="${termsAndConditionsLink}" target="_blank" class="${STYLES.INDEX.PLAN_PICKER.CONFIRMATION.TERMS_OF_USE_LINK}">${termsAndConditionsLinkTitle}</a>
          and
         <a id='VISA_SAVING_LINK' href="${visaTermsAndConditionsLink}" target="_blank" class="${STYLES.INDEX.PLAN_PICKER.CONFIRMATION.TERMS_OF_USE_LINK}">${genT('VISA_SAVING.LINK_TITLE')}</a>
      </p>`;

  const getOnCheckedChange = (isChecked: boolean) => {
    if (!isChecked) {
      trackMixPanel('Act on T&C Dialog', {
        Action: 'Approve T&C',
      });
    }
    setIsTermsConfirmed(isChecked);
  };

  return (
    <div className={STYLES.INDEX.PLAN_PICKER.CONFIRMATION.LAYOUT}>

      <Heading
        title={t(TEXT.PLAN_PICKER.CONFIRMATION_TITLE)}
        className={STYLES.INDEX.PLAN_PICKER.CONFIRMATION.TITLE}
      />
      <Heading
        title={t(TEXT.PLAN_PICKER.CONFIRMATION_SUBTITLE)}
        className={STYLES.INDEX.PLAN_PICKER.CONFIRMATION.DESCRIPTION}
      />
      <div className={STYLES.INDEX.PLAN_PICKER.CONFIRMATION.TERMS_OF_USE_CONTAINER}>

        <LiliCheckbox
          id='planPickerConfirmationCheckbox'
          containerClassName='mr-[8px] mt-[4px]'
          size={LiliCheckboxSize.MEDIUM}
          checked={isTermsConfirmed}
          onCheckedChange={getOnCheckedChange}
        />
        <Heading
          title={termsHtml()}
          className=''
          type='HTML'
        />

      </div>
      <LiliButton
        id='acceptPlanTermsButton'
        isLoading={context.isLoading}
        title={t(TEXT.PLAN_PICKER.ACCEPT_BUTTON)}
        className={STYLES.INDEX.PLAN_PICKER.CONFIRMATION.BUTTON}
        disabled={!isTermsConfirmed}
        onClick={onTermsConfirmedHandler}
      />
    </div>
  );
};
